import { render } from "./OcrExcelFileGrid.vue?vue&type=template&id=b28772da"
import script from "./OcrExcelFileGrid.vue?vue&type=script&lang=js"
export * from "./OcrExcelFileGrid.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__